<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4>المشرفين</h4>
        </div>
        <div class="card-body">
          <div class="col-12 table-responsive">
            <table class="table table-hover table-bordered custom-table">
              <thead>
                <th>اسم المستخدم</th>
                <th>الجوال</th>
                <th>خيارات</th>
              </thead>
              <tbody>
                <tr v-for="place in admins" :key="place._id">
                  <td>
                    {{ place.username }}
                  </td>
                  <td>
                    {{ place.phone }}
                  </td>
                  <td>
                    <button
                      class="btn btn-sm btn-success"
                      @click="$router.push('/admins/edit/' + place._id)"
                    >
                      <i class="fa fa-edit"></i>
                    </button>
                    <button
                      class="btn btn-sm btn-outline-danger"
                      style="margin-right: 3px"
                      @click="deletePlace(place._id)"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      admins: [],
    };
  },
  created() {
    var g = this;
    $.post(api + "/console/admins/list", {
      jwt: user.jwt,
    }).then(function (r) {
      g.admins = r.response;
    });
  },
  methods: {
    deletePlace(id) {
      var g = this;
      if (confirm("متأكد من الحذف؟")) {
        $.post(api + "/console/admins/delete", {
          jwt: user.jwt,
          id: id,
        }).then(function () {
          location.reload();
        });
      }
    },
  },
};
</script>

<style>
</style>